
export const instagramLink = "https://www.instagram.com/garbage_garage_shop";
export const whatsappLink = "https://wa.me/381612053244";
export const telegramLink = "https://t.me/garbage_garage";
